import Helper from './Helper';

class Strategy {
  constructor(config = {}) {
    const {
      strategyItem
    } = config

    this.strategyItem = strategyItem;
    this.items = Array.prototype.slice.call(document.querySelectorAll(strategyItem));
    // console.log(this.items);

    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach(el => {
      el.addEventListener('click', (e) => {
        const lastActive = document.querySelector('.ns-strategy__item.active');

        if(!! lastActive ) {
         lastActive.classList.remove('active');
        }

        el.classList.add('active');
      } );
    });
  }
}

export default Strategy;
